import React, { Component } from "react";
import i18n from "i18next";
import PropTypes from "prop-types";
import AppModal from "../common/modal/AppModal";
import IdealStudio from "../../../core/editor/main";

export default class ExitModal extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.showExitModal && !prevProps.showExitModal) {
      window.exitFlag = true;
    }
    if (!this.props.showExitModal && prevProps.showExitModal) {
      window.exitFlag = null;
    }
  }

  render() {
    const footer = (
      <div className="app-modal__footer">
        <button
          type="button"
          className="app-modal__btn app-modal__btn--ghost"
          onClick={() => this.props.closeExitModal()}
        >
          {i18n.t("exitModal.cancel")}
        </button>
        <button
          type="button"
          className="app-modal__btn app-modal__btn--ghost"
          onClick={() => {
            IdealStudio.Visor.exitLSEditorPage();
          }}
        >
          {i18n.t("exitModal.leave_without_changes")}
        </button>
        <button
          type="button"
          className="app-modal__btn app-modal__btn--primary"
          onClick={() => {
            this.props.closeExitModal();
            this.props.save();
          }}
        >
          {i18n.t("exitModal.save_and_exit")}
        </button>
      </div>
    );

    return (
      <AppModal
        show={!!this.props.showExitModal}
        onClose={this.props.closeExitModal}
        title={i18n.t("exitModal.Title")}
        size="md"
        closeButton={false}
        showSceneToggle={false}
        footer={footer}
      >
        {i18n.t("exitModal.Body")}
      </AppModal>
    );
  }
}

ExitModal.propTypes = {
  showExitModal: PropTypes.bool,
  status: PropTypes.string,
  save: PropTypes.func.isRequired,
  closeExitModal: PropTypes.func.isRequired,
};
